import { render, staticRenderFns } from "./CardRequests.vue?vue&type=template&id=9bca470e&"
import script from "./CardRequests.vue?vue&type=script&lang=js&"
export * from "./CardRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports